<template>

    <b-col>
        <b-form-group label-align="left" v-if="(field.sections.includes(getSelectedSection.name)) && field.programs.includes(getSelectedProgram(scenarioName)) || field.name === 'Program'">
            <slot name="label">
                {{field.name}}
            </slot>
            <el-popover
                placement="right-end"
                v-if="field.encompassValues.length > 0"
                trigger="click">
                <el-table :data="field.encompassValues">
                    <el-table-column width="200" property="id" label="ID"></el-table-column>
                    <el-table-column width="300" property="name" label="Name"></el-table-column>
                    <el-table-column width="300" property="value" label="Value"></el-table-column>
                </el-table>
                <i class="fas fa-info-circle fa-sm text-ao-light info-bubble" slot="reference"></i>
            </el-popover>
            <el-popover 
                trigger="hover" 
                v-else
                placement="top" 
                content="No Encompass ID" 
                popper-class="id-popover">
                <i class="fas fa-question-circle fa-sm text-ao-light" slot="reference"></i>
            </el-popover>
            
            <!-- Numeric field inputs -->
            <b-form-input 
                :type="convertType(field.type)"
                step="any" 
                :value="getValue(field).value" 
                v-model="field[getValue(field).prop]"
                v-if="field.type === 'numeric'"
                @input="
                    touchField(field);
                    setHasRun(false);
                "
                :state="inputState()"
                class="mt-2"
                :class="backgroundStyle"
                @wheel="$event.target.blur()"
                :disabled="field.encompassValues.length !== 0"
                :data-test="`halo-input-${field.name}`"
            ></b-form-input>

            <!-- Text field inputs -->
            <b-form-select 
                :value="getValue(field).value" 
                :options="field.options"
                v-model="field[getValue(field).prop]" 
                v-if="field.type === 'text'"
                @input="
                    touchField(field);
                    setHasRun(false);
                "
                :state="inputState()"
                class="mt-2"
                :class="backgroundStyle"
                :disabled="field.encompassValues.length !== 0"
                :data-test="`halo-input-${field.name}`"
            ></b-form-select>

            <!-- Date field inputs -->
            <b-input-group>
                <b-form-input
                    :value="getValue(field).value" 
                    v-model="field[getValue(field).prop]"
                    v-if="field.type === 'date'"
                    @input="
                        touchField(field);
                        setHasRun(false);
                    "
                    type="date"
                    :state="inputState()"
                    class="mt-2"
                    :class="backgroundStyle"
                    :disabled="field.encompassValues.length !== 0"
                    :data-test="`halo-input-${field.name}`"
                ></b-form-input>
            </b-input-group>
        </b-form-group>
    </b-col>

</template>

<script>
import useVuelidate from "@vuelidate/core";
import { mapMutations, mapGetters } from "vuex";
import { helpers } from '@vuelidate/validators';
import { findValue } from '@/utils/FindValue'
import { Table, TableColumn } from 'element-ui';


export default {
    setup() {
        return { v$: useVuelidate() }
    },
    props: {
        field: Object,
        scenarioName: String,
        different: String
    },
    components: {
        ['ElTable']: Table,
        ['ElTableColumn']: TableColumn,
    },
    computed: {
        ...mapGetters(["getSelectedProgram", "getSelectedSection"]),

        backgroundStyle() {
            let style = '';
            if (this.different === 'new') {
                style = 'highlight-new';
            } else if (this.different === 'different') {
                style = 'highlight-different';
            }
            return style;
        }
    },
    methods: {
        ...mapMutations([
            "setHasRun"
        ]),

        convertType(mappedType) {
            // converts the type of inputs from the mapping to html input types
            let inputType = "";
            if (mappedType === "numeric") {
                inputType = "number";
            } else if (mappedType === "date") {
                inputType = "date";
            } else {
                inputType = "text";
            }
            return inputType;
        },

        getValue(field) {
            return findValue(field);
        },

        touchField(field) {
            this.v$.field[this.getValue(field).prop].$touch();
        },

        inputState() {
            // gets and displays the validity of an input
            try {
                return !this.v$.field[this.getValue(this.field).prop].$error ? null : !this.v$.field[this.getValue(this.field).prop].$invalid;
            } catch (err) {
                console.log(err);
            }
        },

        checkIfPresent(type) {
            const result = this.field.type === type && ((this.field.programs.includes(this.getSelectedProgram(this.scenarioName))) || this.field.name === 'Program');
            return result;
        },

        checkIfRequired() {
            // used to check if validation is required for a certain field
            const fieldInfo = this.getValue(this.field);
            const value = fieldInfo.value;
            const prop = fieldInfo.prop;
            let check;
            if (this.field.required) {
                if (prop === "dateValue") {
                    // if field is date and required make sure it is not set as 'No Date'.
                    check = value !== 'No Date' && value !== '' && value !== undefined;
                } else {
                    // if field is text or numeric and required make sure it is not undefined
                    check = value !== undefined && value !== "" && value !== null;
                }
            } else if (value === undefined || value == null) {
                // gets rid of null value to avoid db error
                check = true;
                this.field[prop] = "";
            } else {
                // validation not required but does not erase currently stored value
                check = true;
            }
            return check;
        },
    },

    validations() {
        if (this.checkIfPresent("numeric")) {
            return {
                field: {
                    numericValue: {
                        minValue: helpers.withMessage(
                            `${this.field.param}`,
                            function() {
                                return this.checkIfRequired()
                            },  
                        ),
                    },
                }
            }
        } else if (this.checkIfPresent("text")) {
            return {
                field: {
                    textValue: {
                        exist: helpers.withMessage(
                            `${this.field.param}`,
                            function() {
                                return this.checkIfRequired()
                            },  
                        ),
                    },
                }
            }
        } else if (this.checkIfPresent("date")) {
            return {
                field: {
                    dateValue: {
                        exists: helpers.withMessage(
                            `${this.field.param}`,
                            function() {
                                return this.checkIfRequired()
                            },  
                        ),
                    }
                }
            };
        }
    },
};
</script>

<style>
input[type="date"]::-webkit-calendar-picker-indicator {
    display: none;
    -webkit-appearance: none;
}

select{
    box-shadow: none !important;
    height: 46px !important;
    border-bottom-left-radius: 4px !important;
    border-bottom-right-radius: 4px !important;
    border-top-left-radius: 4px !important;
    border-top-right-radius: 4px !important;
    
}

.el-table .cell {
    padding-left: 0px;
    padding-right: 0px;
    word-break: break-word;
    font-size: 14px;
}

.custom-select:disabled {
    color: #8898aa !important;
    opacity: 1;
    background: none;
    background-color: #e9ecef;
}

.highlight-different {
    background-color: rgb(0, 221, 255, .35) !important;
}

.highlight-new {
    background-color: rgba(0, 100, 255, 0.25) !important;
}

.id-popover {
    padding: 8px;
}

.info-bubble {
    cursor: pointer
}
</style>